import type { ReactNode } from 'react';
import DashboardIcon from '@mui/icons-material/esm/Dashboard';
import PmDashboardIcon from '@mui/icons-material/esm/Engineering';
import TaskIcon from '@mui/icons-material/esm/Assignment';
import QsIcon from '@mui/icons-material/esm/AssignmentTurnedIn';
import AdminIcon from '@mui/icons-material/esm/AdminPanelSettings';
import PermitIcon from '@mui/icons-material/esm/FactCheck';
import InspectionIcon from '@mui/icons-material/esm/Rule';
import ChecklistIcon from '@mui/icons-material/esm/Checklist';
import InsightsIcon from '@mui/icons-material/esm/Insights';
import ChangeRequestIcon from '@mui/icons-material/esm/ChangeCircle';
import FieldModeIcon from '@mui/icons-material/esm/PhoneAndroid';
import DfrIcon from '@mui/icons-material/esm/Article';
import TimesheetIcon from '@mui/icons-material/esm/AccessTime';
import SyncConflictIcon from '@mui/icons-material/esm/SyncProblem';
import HomeWork from '@mui/icons-material/esm/HomeWork';
import Storefront from '@mui/icons-material/esm/Storefront';
import Workspaces from '@mui/icons-material/esm/Workspaces';
import AccountBalance from '@mui/icons-material/esm/AccountBalance';
import RiskIcon from '@mui/icons-material/esm/ReportProblem';
import Verified from '@mui/icons-material/esm/Verified';
import HealthAndSafety from '@mui/icons-material/esm/HealthAndSafety';
import Gavel from '@mui/icons-material/esm/Gavel';
import PrecisionManufacturing from '@mui/icons-material/esm/PrecisionManufacturing';
import CalendarMonth from '@mui/icons-material/esm/CalendarMonth';
import NotificationsIcon from '@mui/icons-material/esm/Notifications';
import Description from '@mui/icons-material/esm/Description';
import { routePaths } from '../../routes/routePaths';

export type MenuItemConfig = {
  text: string;
  icon: ReactNode;
  path: string;
};

export type MenuSectionConfig = {
  id: string;
  text: string;
  icon: ReactNode;
  items: MenuItemConfig[];
};

export const menuSections: MenuSectionConfig[] = [
  {
    id: 'overview',
    text: 'Overview',
    icon: <DashboardIcon />,
    items: [
      { text: 'Dashboard', icon: <DashboardIcon />, path: routePaths.dashboard },
      { text: 'PM Dashboard', icon: <PmDashboardIcon />, path: routePaths.pmDashboard },
      { text: 'Dispatch Board', icon: <TaskIcon />, path: routePaths.dispatchBoard },
    ],
  },
  {
    id: 'field-operations',
    text: 'Field Operations',
    icon: <FieldModeIcon />,
    items: [
      { text: 'Field Mode', icon: <FieldModeIcon />, path: routePaths.field },
      { text: 'Daily Field Reports', icon: <DfrIcon />, path: routePaths.dfr },
      { text: 'Timesheets', icon: <TimesheetIcon />, path: routePaths.timesheets },
      { text: 'Inspections & NCRs', icon: <InspectionIcon />, path: routePaths.inspections },
      { text: 'Permits', icon: <PermitIcon />, path: routePaths.permits },
      { text: 'QC Templates', icon: <ChecklistIcon />, path: routePaths.qcTemplates },
      { text: 'Defects', icon: <InspectionIcon />, path: routePaths.defects },
      { text: 'HSE Register', icon: <HealthAndSafety />, path: routePaths.hse },
    ],
  },
  {
    id: 'money-supply',
    text: 'Money & Supply',
    icon: <AccountBalance />,
    items: [
      { text: 'QS Workspace', icon: <QsIcon />, path: routePaths.qs },
      { text: 'Procurement', icon: <HomeWork />, path: routePaths.procurement },
      { text: 'Stores', icon: <Storefront />, path: routePaths.stores },
      { text: 'Resources / Inventory', icon: <Storefront />, path: routePaths.resources },
      { text: 'Equipment', icon: <PrecisionManufacturing />, path: routePaths.equipment },
      { text: 'Accounts', icon: <AccountBalance />, path: routePaths.accounts },
      { text: 'Financials', icon: <AccountBalance />, path: routePaths.financials },
      { text: 'Budget', icon: <Workspaces />, path: routePaths.budget },
      { text: 'Contract Admin', icon: <Gavel />, path: routePaths.contractAdmin },
      { text: 'Change Requests', icon: <ChangeRequestIcon />, path: routePaths.changeRequests },
    ],
  },
  {
    id: 'project-controls',
    text: 'Project Controls',
    icon: <Workspaces />,
    items: [
      { text: 'WBS', icon: <Workspaces />, path: routePaths.wbs },
      { text: 'Unit Status', icon: <Verified />, path: routePaths.unitStatus },
      { text: 'Risk Register', icon: <RiskIcon />, path: routePaths.risks },
      { text: 'Reports', icon: <InsightsIcon />, path: routePaths.reports },
      { text: 'Documents', icon: <Description />, path: routePaths.documents },
    ],
  },
  {
    id: 'admin',
    text: 'Admin',
    icon: <AdminIcon />,
    items: [
      { text: 'Admin', icon: <AdminIcon />, path: routePaths.admin },
      { text: 'Work Calendars', icon: <CalendarMonth />, path: routePaths.workCalendars },
      { text: 'Notifications', icon: <NotificationsIcon />, path: routePaths.notifications },
      { text: 'Sync Conflicts', icon: <SyncConflictIcon />, path: routePaths.syncConflicts },
    ],
  },
];
